export default class Log {
    static {
        this.d = !import.meta.env.PROD ? console.debug.bind(console) : () => {};
        this.m = console.log.bind(console);
        this.i = console.info.bind(console);
        this.w = console.warn.bind(console);
        this.e = console.error.bind(console);
    }
}